<template>
  <PodcastPaywall :podcast="context">
    <template #active>
      <SingleColumn v-if="success">
        <template #header>
          <h1 class="text-3xl font-bold text-white">
            {{ resource.subject }}
          </h1>
        </template>
        <template #content>
          <section class="section">
            <div class="px-4 py-5 sm:px-6">
              <p class="mt-1 text-sm text-gray-500">
                {{ resource.message }}
              </p>
            </div>
          </section>
        </template>
      </SingleColumn>
    </template>
    <template #inactive>
      <SingleColumn>
        <template #header>
          <section class="sm:flex sm:items-center sm:justify-between">
            <div class="sm:flex sm:space-x-5">
              <h1 class="text-3xl font-bold text-white">
                Die Kompass-KI ist Teil vom Studio Pro
              </h1>
            </div>
          </section>
        </template>
        <template #content>
          <ConversionTrigger :podcast="context" />
        </template>
      </SingleColumn>
    </template>
  </PodcastPaywall>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRetrieveResource } from '@/client/actions';

const props = defineProps({id: String});
const store = useStore();

const context = computed(() => store.getters['context/context']);

const target = computed(() => '/api/assistances/' + props.id);
const action = useRetrieveResource(target);

const { resource, retrieving, retrieve, success } = action;

const onMount = onMounted(() => retrieve());
</script>

<style scoped>
.section
{
  @apply bg-white shadow;
  @apply overflow-hidden;
  @apply sm:rounded-lg;
};
</style>
